import { render, staticRenderFns } from "./ercode-block.vue?vue&type=template&id=39bc9130&scoped=true"
import script from "./ercode-block.vue?vue&type=script&lang=js"
export * from "./ercode-block.vue?vue&type=script&lang=js"
import style0 from "./ercode-block.vue?vue&type=style&index=0&id=39bc9130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc9130",
  null
  
)

export default component.exports